export const OPENTABLE_NEW_AGENT_UI_COPY = {
  voice: {
    title: "Select your agent's voice",
    moreVoices: 'More voices are available to select in PolyHost.',
  },
  websiteUrl: {
    title: 'Set up your agent using your website',
    titleOptional: '(Optional)',
    description:
      "Skip the manual work of updating your agent by pasting your restaurant website and we'll automatically fill in your opening hours, location, policies, FAQs and contact details.",
    label: 'Company website (optional)',
    tooltip:
      "Use the website that has information about things like opening times for your specific restaurant, we'll do the rest",
    placeholder: 'https://yourrestaurant.com',
    skipCta: 'Skip for now',
    continueCta: 'Continue',
  },
} as const;
